import React from "react";

import {
    Image,
    Platform,
    Text,
    TouchableOpacity,
    TouchableOpacityProps,
    View
} from "react-native";
import Activity from "../../../models/Activity";
import Images from "../../../../specific/utils/Images";
import AppTheme from "../../../utils/Theme";
import { getLanguage } from "../../../utils/Localization/Localization";
import User from "../../../data/user/User";
import { getMenuConfiguration, LEVEL_CONF } from "../../Menu/MenuConf";
import Fonts from "../../../Theme/Fonts";

interface ActivitySquareButtonProps extends TouchableOpacityProps {
    activity: Activity;
    font?: "bold" | "regular";
    align?: "left" | "center";
    size?: "s" | "m" | "l";
    imageFixedSize?: number;
    gap?: number;
    color?: string;
}

const ActivitySquareButton = (props: ActivitySquareButtonProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();

    const user: User = User.getInstance();
    const levelConfiguration: LEVEL_CONF = getMenuConfiguration(user.children_level);

    const { activity, font = "bold", align = "center", size = "m", gap, imageFixedSize, color = levelConfiguration.text_color, ...restProps } = props;

    const refWidth = Platform.OS === "web" ? appTheme.getBlockWidth() : appTheme.getFullAppWidth();
    let cellSize = (refWidth - appTheme.pixelPerfect(60)) / 3;
    let imageSize = size === "s" ? appTheme.pixelPerfect(80) : size === "m" ? appTheme.pixelPerfect(100) : appTheme.pixelPerfect(120);
    if (imageSize > (cellSize - appTheme.pixelPerfect(10))) {
        imageSize = gap !== undefined ? cellSize - gap : cellSize - appTheme.pixelPerfect(10);
    }
    if (imageFixedSize !== undefined) {
        imageSize = imageFixedSize;
        cellSize = imageSize + appTheme.pixelPerfect(10);
    }
    if (gap !== undefined) {
        cellSize = imageSize + gap;
    }
    

    // On va chercher l'image de la première activité de la catégorie
    let activityImage: number | { uri: string } | undefined = undefined;
    if ((activity.img_url !== undefined) && (activity.img_url.length > 0)) {
        activityImage = { uri: activity.img_url };
    }
    if ((activity.app_image !== undefined) && (activity.app_image.length > 0) && (images[activity.app_image] !== undefined)) {
        activityImage = images[activity.app_image];
    }
    return <TouchableOpacity key={activity.key} style={{ width: cellSize, alignItems: "center", justifyContent: "center" }} {...restProps}>
        <Image source={activityImage} style={{ width: imageSize, height: imageSize, borderRadius: 20 }} resizeMode="cover" />
        <View style={{ marginTop: appTheme.pixelPerfect(5), width: "96%", justifyContent: "flex-start", flex: 1}}>
            <Text numberOfLines={3} style={{ fontFamily: font === "bold" ? Fonts.primary.bold : Fonts.primary.regular, color, textAlign: align, fontSize: size === "s" ? appTheme.pixelPerfectForFont(5) : appTheme.pixelPerfectForFont(7) }}>{activity.title[getLanguage()]}</Text>
        </View>
    </TouchableOpacity>

}

export default ActivitySquareButton;

